// ----------------------------------------------------------------------
// <copyright file="Izenda.AdvancedSettings.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Advanced Settings component
 */
!(function() {
  var connect = require('share/enhancers/Izenda.Connect');

  var MiddlePanel = require('share/components/layout/Izenda.MiddlePanel');
  var MainContent = require('share/components/layout/Izenda.MainContent');
  var ContextMenu = require('share/components/layout/Izenda.ContextMenu');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var AdvancedSettingsConstants = require('logic/data/Izenda.AdvancedSettingsConstants');
  var uiState = require('logic/Izenda.UiState');

  var React = require('react');
  const { filter, head, placeholder } = require('lodash/fp');
  var viewComponents = {
    performance: {
      component: require('./Izenda.Performance'),
      storePath: 'performance'
    },
    security: {
      component: require('./Izenda.Security'),
      storePath: 'security'
    },
    others: {
      component: require('modules/Settings/DataSetup/AdvancedSetting/Others/Izenda.Others'),
      storePath: 'others'
    },
    category: {
      component: require('./Category/Izenda.Category'),
      storePath: 'category'
    },
    notFound: {
      component: require('share/components/controls/Izenda.NotFound')
    }
  };

  function getComponentInfo(key) {
    return placeholder(viewComponents).get(key, viewComponents.notFound);
  }

  var AdvancedSettings = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    componentWillMount: function() {
      var authorization = this.props.authorization;
      this.menu = filter(function(item) {
        // Do not show menu which is for system user, when current user is not a system user.
        if (item.forSystemAdmin && !uiState.currentUser.systemAdmin) return false;

        if (item.permissionKeys) {
          if (item.permissionOperator) {
            if (!authorization.checkPrivileges(item.permissionKeys, item.permissionOperator)) {
              return false;
            }
          } else {
            if (!authorization.checkPrivileges(item.permissionKeys)) {
              return false;
            }
          }
        }
        return true;
      }, AdvancedSettingsConstants.MENU);

      this.setInitialSelectedItem();
    },

    /**
     * Build initial selected item.
     */
    setInitialSelectedItem: function() {
      var initialSelectedItem = head(this.menu);
      initialSelectedItem && this.changeItem(initialSelectedItem.key);
    },

    /**
     * Handle change selected item
     */
    changeItem: function(newLink) {
      var store = this.props.store;
      if (store.activeLink !== newLink) {
        this.props.confirmDirtyForm(uiState.isDirty, { onConfirmDirtyForm: uiState.onOkDirtyForm }).then(function() {
          store.changeSelectItem(newLink);
        });
      }
    },

    /**
     * Render right content when click middle panel
     */
    renderRightContent: function() {
      var info = getComponentInfo(this.props.store.activeLink);
      var store = info.storePath ? placeholder(this.props.store).get(info.storePath) : null;
      return store ? <info.component store={store} /> : <info.component />;
    },
    /**
     * Render middle panel
     */
    renderMiddlePanel: function() {
      return (
        <MiddlePanel>
          <ContextMenu
            dataSource={this.menu}
            activeKey={this.props.store.activeLink}
            enabled={true}
            onSelected={this.changeItem}
            className="izenda-DataModel-Middle"
          />
        </MiddlePanel>
      );
    },

    /**
     * Render main content
     */
    renderMainContent: function() {
      return <div className="izenda-TableLayout-Cell">{this.renderRightContent()}</div>;
    },
    render: function() {
      var store = this.props.store;

      return (
        <div className="izenda-AdvancedSettings izenda-TableLayout">
          {this.renderMiddlePanel()}
          {this.renderMainContent()}
        </div>
      );
    }
  });

  module.exports = connect()(AdvancedSettings);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/AdvancedSetting/Izenda.AdvancedSettings.jsx